import { ImageViewer as ImageViewerComponent } from './ImageViewer';

export const ImageViewer = ImageViewerComponent;
